import * as React from "react";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { buildingsByProducedResourceId } from "../balancing/types/buildingsByProducedResourceId";
import { ButtonSecondaryAccentExtraLarge } from "../generic/common/ButtonSecondaryAccentExtraLarge";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
export var ButtonShowMeNotEnoughResources = function (_a) {
    var missingResources = _a.missingResources, onClick = _a.onClick;
    var missingResource = missingResources[0];
    var missingResourceId = missingResource.resource.id;
    var isResourceGold = missingResourceId === IdResource.Gold;
    var isResourceMoney = missingResourceId === IdResource.Money;
    var isResourceProducible = buildingsByProducedResourceId.has(missingResourceId);
    if (isResourceGold || isResourceMoney || !isResourceProducible) {
        return React.createElement(React.Fragment, null);
    }
    var resource = missingResource.resource, missing = missingResource.missing;
    var taskType = {
        amount: missing.toNumber(),
        index: 1,
        locaKey: resource.locaKey,
        recipeIds: "",
        resourceId: resource.id,
    };
    return (React.createElement(ButtonSecondaryAccentExtraLarge, { onClick: function () { return onClick(taskType); } },
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.showMe })),
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(Icon, { icon: IdIcon.GreenArrowIcn, styleId: IdStyles.IconMedium })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/ButtonShowMeNotEnoughResources.tsx
// module id = 2852
// module chunks = 3